import { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "react-perfect-scrollbar/dist/css/styles.css";
import { Provider } from "react-redux";
import "tippy.js/dist/tippy.css";
import App from "./App";
import ReusableToast from "./components/custom/custom-toast";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { ExpiredProvider } from "./state/expired-context";
import { LoadingProvider } from "./state/loading-context";
import store from "./store";
import "./tailwind.css";

declare global {
  interface Window {
    env: any;
  }
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <ExpiredProvider>
    <LoadingProvider>
      <Suspense>
        <Provider store={store}>
          <App />
          <ReusableToast />
        </Provider>
      </Suspense>
    </LoadingProvider>
  </ExpiredProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
